/*
payment/payment/index

usage:

*/

import actions from '../common/lib/utils/actions.js';
import asynchronousResultAfterSingleCall from './lib/asynchronous-result-after-single-call.js';
import constants from './../common/lib/utils/constants.js';
import fetchFeesAndLimits from './lib/fetch-fees-and-limits.js';
import fetchPaymentmethods from './lib/fetch-paymentmethods.js';
import fetchMethodDetails from './lib/fetch-methoddetails.js';
import immediatePaymentResultRouter from './lib/immediate-payment-result-router.js';
import firstTimeUkDeposit from './lib/first-time-uk-deposit.js';
import paymentmethods from './lib/paymentmethods.js';
import submitPayment from './lib/submit-payment.js';
/* view contains all dom-elements and updates the rendering */
import view from './lib/view.js';
import resultAfterSingleCall from './lib/result-after-single-call.js';
import externalPanelAndWindowHandler from './lib/external-panel-and-window-handler.js';
import sendHandlerController from './lib/send-handler-controller.js';
import dataflow from './../common/lib/dataflow.js';

const register = dataflow.register;
const conf = {
	methodsUrl: '/PaymentFormDataService/getDepositPaymentMethods?isMobileDevice=true',
	feesAndLimitsUrl: '/PaymentFormDataService/getDepositFeesAndLimits/forMobile'
};

function initialization() {
	/* most modules used in the app are init from here. They are then connected */
	fetchFeesAndLimits.init(conf.feesAndLimitsUrl);
	fetchPaymentmethods.init(conf.methodsUrl);
	fetchMethodDetails.init();
	paymentmethods.init();
	submitPayment.init();
	view.init(conf);
	/* fetchPaymentmethods gets the first necessary data from ajaxcall. These
	 *  data are then distributed to the 'stores' via an action and the connected views (all visual dom-nodes) are then updated.
	 * this action starts the fetchPaymentmethods and other stores registered for the action */
	resultAfterSingleCall.init();
	externalPanelAndWindowHandler.init();
	asynchronousResultAfterSingleCall.init();
	sendHandlerController.init();
	immediatePaymentResultRouter.init();
	firstTimeUkDeposit.init();
	actions.setupPayment();
}

function registerActions() {
	function paymentinit(payload) {
		if (payload.type === constants.SUBMIT_PAYMENT) {
			if (payload.success) {
				/* The depositflow is done */
				view.close();
			}
		}
	}
	register(paymentinit);
}

function initializationForShopDepositBonus() {
	fetchFeesAndLimits.init(conf.feesAndLimitsUrl);
	submitPayment.init();
}

export default {
	init(p) {
		conf.wrap = (p.wrapElmSelector || null);
		conf.isEmptyCallback = (p.isEmptyCallback || null);
		conf.ageverifycb = (p.ageverifycb || null);
		conf.agedontverifycb = (p.agedontverifycb || null);
		conf.complianceverifycb = (p.complianceverifycb || null);
		conf.compliancedontverifycb = (p.compliancedontverifycb || null);
		registerActions();
		initialization();
	},
	shopInit() {
		initializationForShopDepositBonus();
	},
	close() {
		view.close();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/index.js